export default {
    ABOUT: "О приложении"
};
